import { SidebarProvider } from "@/components/ui/sidebar";
import Teacherheader from "./Teacherheader";
import Teachersidebar from "./Teachersidebar";
import SuspensionWarning from "./SuspensionWarning";
import useSuspensionCheck from "./useSuspensionCheck";
import { LibraryContent } from "@/components/library/LibraryContent";

const TeacherLibraryManagement = () => {
  // Check suspension status
  const { isSuspended, isLoading: suspensionLoading, schoolName: suspendedSchoolName } = useSuspensionCheck();

  // Show suspension warning if teacher is suspended
  if (isSuspended) {
    return <SuspensionWarning schoolName={suspendedSchoolName} isLoading={suspensionLoading} />;
  }

  if (suspensionLoading) {
    return (
      <SidebarProvider>
        <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
          <Teachersidebar />
          <div className="flex flex-col flex-1 h-full">
            <Teacherheader />
            <div className="flex-1 overflow-y-auto p-3 sm:p-6 bg-gray-50 dark:bg-gray-900 flex justify-center items-center">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          </div>
        </div>
      </SidebarProvider>
    );
  }

  return (
    <SidebarProvider>
      <div className="flex h-screen w-full bg-gray-50 dark:bg-gray-900">
        <Teachersidebar />
        <div className="flex flex-col flex-1 h-full">
          <Teacherheader />
          <main className="flex-1 p-2 sm:p-4 lg:p-6 overflow-auto dark:bg-[#020817] stable-gutter">
            <LibraryContent />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default TeacherLibraryManagement;
